module.exports = __webpack_public_path__ + "static/media/statistics.2bb7896f.svg";